export interface RefreshState {
  pending: Promise<boolean> | null
}

/** Share one renewal, including its token updates and failure notification. */
export function runSharedRefresh(state: RefreshState, refresh: () => Promise<boolean>): Promise<boolean> {
  if (!state.pending) {
    const pending = Promise.resolve().then(refresh).finally(() => {
      if (state.pending === pending) state.pending = null
    })
    state.pending = pending
  }
  return state.pending
}
